<template>
    <div>
        <md-table v-model="rows" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="">
                    <md-checkbox v-model="item.checked" @change="checkRow(item)" :disabled="!cartIsReady || ((item.latitude === '' || item.latitude === null) && (item.longitude === '' || item.longitude === null))"></md-checkbox>
                </md-table-cell>
                <md-table-cell md-label="Secteur - Mois">
                    <div class="font-medium leading-none mb-0.5">{{ item.sector_name ? item.sector_name : 'Ø' }}</div>
                    <div class="leading-none text-2xs" v-if="type !== 'oneTimes'">{{ formatMonthName(item.month, 'monthNumber') }}</div>
                    <div class="leading-none text-2xs" v-else>{{ formatMonthName(item.date, 'date') }}</div>
                </md-table-cell>
                <md-table-cell md-label="Client">
                    <div class="font-medium">
                        {{ item.client_num }}
                        <span class="text-info cursor-pointer leading-none mb-0.5"
                              @mousedown="goToRoute($event, 'Client Details', {id: item.client_id})">
                            {{ item.client_name }}
                        </span>
                    </div>
                    <div class="leading-none text-2xs" v-if="item.contract_id">
                        <span class="text-info cursor-pointer leading-none mb-0.5"
                              @mousedown="goToRoute($event, 'Contract Details', { contractId: item.contract_id })">
                            {{ item.contract_number }}
                        </span>

                        <span v-if="item.contractInformation"
                        :class="contractInformationColor(item)">{{ item.contractInformation.text }}</span>
                    </div>
                </md-table-cell>
                <md-table-cell md-label="Site">
                    <div class="text-info cursor-pointer font-medium leading-none mb-0.5"
                         @mousedown="goToRoute($event, 'Site Details', {id: item.client_id, idSite: item.site_id})">{{ item.site_name }}</div>
                    <div class="leading-none text-2xs">{{ item.city }}</div>
                </md-table-cell>
                <md-table-cell md-label="">
                    <div class="flex items-center space-x-3">
                        <md-button class="md-default md-icon-button md-small-icon md-rounded-icon my-0"
                                   @click="openSiteInformationModal(item.site_id)">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                        </md-button>
                        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0"
                                   :class="item.latitude ? 'md-success' : 'md-danger'">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'map-marker-alt']" />
                        </md-button>
                    </div>
                </md-table-cell>
                <md-table-cell md-label="Durée">
                    <div class="font-medium flex items-center space-x-1"><span class="leading-none">{{ hoursAndMinutes(item.duration) }}</span> <span class="leading-none">{{ displaySmartSiteInformations(item) }}</span></div>
                    <div class="leading-none text-2xs" v-if="type !== 'oneTimes'">{{ formatMonthName(item.month, 'monthNumber') }}</div>
                    <div class="leading-none text-2xs" v-else>{{ formatMonthName(item.date, 'date') }}</div>
                </md-table-cell>
                <md-table-cell md-label="Type">
                    <div class="font-medium">{{ item.intervention_type }}</div>
                    <div class="leading-none text-2xs">{{ item.technicians }}</div>
                    <div v-if="type === 'oneTimes'" class="leading-none text-2xs">{{ item.intervention_category }}</div>
                </md-table-cell>
                <md-table-cell md-label="Der. Intervention" v-if="type !== 'oneTimes'">
                    <div class="text-center">{{ item.last_intervention }}</div>
                    <div class="leading-none text-2xs text-danger" v-if="item.is_setting_up">Mise en place à faire</div>
                </md-table-cell>
                <md-table-cell md-label="Commentaire" v-if="type !== 'oneTimes'">
                    <div v-if="item.planning_comment">
                        <span class="font-medium">{{ cropComment(item.planning_comment) }}</span>
                        <md-tooltip v-if="item.planning_comment.length > 25" md-direction="top">{{ item.planning_comment }}</md-tooltip>
                    </div>
                    <span v-else class="italic">Aucun commentaire</span>
                </md-table-cell>
                <md-table-cell md-label="Comm. Intervention">
                    <md-field>
                        <md-input placeholder="Commentaire intervention" :disabled="item.checked" v-model="item.intervention_comment" @keyup.enter="updateInterventionComment(item); $event.target.blur()"></md-input>
                    </md-field>
                </md-table-cell>
                <md-table-cell md-label="">
                    <div v-if="type !== 'oneTimes'">
                        <md-button
                            class="md-danger md-icon-button md-small-icon md-rounded-icon my-0"
							:disabled="item.checked"
							@click="openImpossibleStatusModal(item)">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                        </md-button>
                        <md-tooltip md-direction="top">Non réalisable</md-tooltip>
                    </div>
                    <div v-else>
                        <md-button
							class="md-danger md-icon-button md-small-icon md-rounded-icon my-0"
							:disabled="item.checked"
							@click="openDeleteOneTimeInterventionModal(item)">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                        </md-button>
                        <md-tooltip md-direction="top">Supprimer</md-tooltip>
                    </div>
                </md-table-cell>
            </md-table-row>
        </md-table>
        <div class="flex justify-between items-center mt-1" v-if="totalRows > 0">
            <span>
                Affichage de {{ rows.length }} sur {{ totalRows }} lignes
            </span>
            <md-button class="md-icon-button md-raised md-info"
                       v-if="rows.length != totalRows"
                       @click="getRows">
                <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                <span class="leading-none font-medium ml-2">Afficher plus de lignes</span>
            </md-button>
        </div>
        <div v-else>
            Pas de résultats
        </div>
        <md-dialog :md-active.sync="siteInformationModal.isOpen" :md-fullscreen="false">
            <md-content class="px-3 my-3">
                <span class="text-lg font-medium text-info">Informations sur le site</span>
                <div class="mt-3">
                    <p class="text-sm"><span class="font-medium">Infos planification :</span> {{ siteInformationModal.data.planning_information ? siteInformationModal.data.planning_information : 'Ø' }}</p>
                    <p class="text-sm"><span class="font-medium">Infos horaires :</span> {{ siteInformationModal.data.schedule_comment ? siteInformationModal.data.schedule_comment : 'Ø' }}</p>
                    <md-divider class="my-3 mt-3.5"></md-divider>
                    <div>
                        <span class="font-medium text-base text-info">Horaires d'intervention :</span>
                        <md-list id="schedules" v-if="siteInformationModal.data.schedules && siteInformationModal.data.schedules.length > 0">
                            <md-list-item v-for="schedule in siteInformationModal.data.schedules" :key="schedule.id">
                                <span class="md-list-item-text">
                                    <div class="flex items-center">
                                        <span class="day">{{ dayOfWeek(schedule.day_number) + ' : ' }}</span>
                                        <div class="flex items-center divide-x-2 divide-gray-300">
                                            <span class="px-1 pr-1.5" v-for="subSchedule in schedule.schedules" :key="subSchedule.id">
                                                {{ subSchedule.start + ' à ' + subSchedule.end }}
                                            </span>
                                        </div>
                                    </div>
                                </span>
                            </md-list-item>
                        </md-list>
                        <span v-else class="ml-1">Ø</span>
                    </div>
                </div>
            </md-content>
        </md-dialog>
        <md-dialog :md-active.sync="setImpossibleStatusModal.isOpen" :md-fullscreen="false">
            <md-content class="px-3 my-3" v-if="setImpossibleStatusModal.data">
                <span class="text-lg font-medium">Création d'intervention impossible à programmer</span>
                <div class="mt-3">
                    <p class="text-sm">
                        <span class="font-medium">Client :</span>
                        <span class="text-info cursor-pointer" @mousedown="goToRoute($event, 'Client Details', {id: setImpossibleStatusModal.data.client_id})">
                            {{ setImpossibleStatusModal.data.client_name }} ({{ setImpossibleStatusModal.data.client_num }})
                        </span>
                    </p>
                    <p class="text-sm">
                        <span class="font-medium">Site :</span>
                        <span class="text-info cursor-pointer" @mousedown="goToRoute($event, 'Site Details', {id: setImpossibleStatusModal.data.client_id, idSite: setImpossibleStatusModal.data.site_id})">
                            {{ setImpossibleStatusModal.data.site_name }}
                        </span>
                    </p>
                    <p class="text-sm">
                        <span class="font-medium">Numéro de contrat :</span>
                        <span class="ml-1">{{ setImpossibleStatusModal.data.contract_number }}</span>
                    </p>
                    <p class="text-sm">
                        <span class="font-medium">Mois d'intervention :</span>
                        <span class="ml-1">{{ formatMonthName(setImpossibleStatusModal.data.month) }}</span>
                    </p>
                    <md-divider class="mt-3 mb-8"></md-divider>
                    <form @submit.prevent="addInterventionAsImpossible">
                        <md-field>
                            <label>Commentaire</label>
                            <md-textarea md-autogrow v-model="setImpossibleStatusModal.comment">
                            </md-textarea>
                            <validation-error :errors="apiValidationErrors.comment" />
                        </md-field>
                        <p class="text-xs font-normal">L'intervention sera créée le premier jour du mois, sans technicien assigné et en état "Impossible à programmer".</p>
                        <div class="flex items-center mt-1">
                            <md-button type="submit" class="mr-3 md-success">Créer</md-button>
                        </div>
                    </form>
                </div>
            </md-content>
        </md-dialog>
        <md-dialog :md-active.sync="deleteOneTimeInterventionModal.isOpen" :md-fullscreen="false">
            <md-content class="px-3 my-3">
                <span class="text-lg font-medium">Supprimer une intervention ponctuelle non planifiée</span>
                <p class="text-sm font-normal my-4">Êtes-vous sûr de vouloir supprimer cette intervention ? Attention, cette action est irréversible.</p>
                <div class="flex justify-center">
                    <md-button class="md-danger" @click="deleteOneTimeIntervention">Supprimer</md-button>
                </div>
            </md-content>
        </md-dialog>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
import routerMixin from "@/mixins/router-mixin";

export default {
    name: "ManagementTable",
    components: {
        ValidationError
    },
    props: {
        filter: Object,
        type: String,
        totalRows: Number,
        selectedInterventions: Array,
        cartIsReady: Boolean,
        cartStored: Number
    },
    mixins: [ dateTimeFormattingMixin, formMixin, routerMixin ],
    data() {
        return {
            rows: [],
            siteInformationModal: {
                isOpen: false,
                data: []
            },
            setImpossibleStatusModal: {
                isOpen: false,
                data: [],
                comment: null
            },
            deleteOneTimeInterventionModal: {
                isOpen: false,
                data: [],
            },
        }
    },
    methods: {
        async getRows() {
            if (Object.keys(this.filter).length !== 0) {
                this.$emit('updating')
                let data = []

                if (this.type !== 'oneTimes') {
                    ({ data } = await this.$store.dispatch('planningManagement/getPrevisions', { filter: this.filter, type: this.type, offset: this.rows.length }))
                } else {
                    ({ data } = await this.$store.dispatch('planningManagement/getOneTimeInterventions', { filter: this.filter, type: this.type, offset: this.rows.length }))
                }

                let cart = localStorage.getItem('management-prevision-cart')
                if (cart !== 'undefined') {
                    cart = JSON.parse(localStorage.getItem('management-prevision-cart') ?? '[]')
                } else {
                    cart = []
                }
                this.setCheckedRows(data, cart.interventions)
                if (this.rows.length) {
                    this.rows = this.rows.concat(data)
                } else {
                    this.rows = data
                }
                this.$emit('loaded', this.rows)
            }
        },
        async getSiteInformation(id) {
            const { data } = await this.$store.dispatch('sites/getSiteInformation', { siteId: id })
            this.siteInformationModal.data = data
            this.siteInformationModal.data.schedules = this.formatSchedules(this.siteInformationModal.data.schedules)
        },
        formatSchedules(data) {
            let schedules = []
            data.map(d => {
                let sameSchedule = schedules.filter(s => { return s.day_number === d.day_number })
                if(sameSchedule.length > 0) {
                    sameSchedule[0].schedules.push({
                        id: d.id,
                        start: d.start,
                        end: d.end
                    })
                } else {
                    let schedule = {
                        ...d,
                        schedules: [{
                            id: d.id,
                            start: d.start,
                            end: d.end
                        }]
                    }
                    schedules.push(schedule)
                }
            })
            return schedules
        },
        cropComment(comment) {
            return comment ? (comment.length > 25 ? comment.substring(0, 25) + '...' : comment) : ''
        },
        displaySmartSiteInformations(item) {
            return item.site_is_smart ? '(S)' : (item.site_is_baiting_unpermanent ? '(12)' : '')
        },
        openSiteInformationModal(id) {
            this.siteInformationModal.isOpen = true
            this.siteInformationModal.data = []
            this.getSiteInformation(id)
        },
        openImpossibleStatusModal(item) {
            this.setImpossibleStatusModal.isOpen = true
            this.setImpossibleStatusModal.data = item
        },
        openDeleteOneTimeInterventionModal(item) {
            this.deleteOneTimeInterventionModal.isOpen = true
            this.deleteOneTimeInterventionModal.data = item
        },
        async addInterventionAsImpossible() {
            this.$emit('updating')
            await this.$store.dispatch('interventions/addInterventionAsImpossible', {
				comment: this.setImpossibleStatusModal.comment,
	            prevision_id: this.setImpossibleStatusModal.data.prevision_id,
	            intervention_id: this.setImpossibleStatusModal.data.intervention_id,
				filter: this.filter
			})
	        this.setImpossibleStatusModal = {
		        isOpen : false,
		        data : null,
		        comment : null
	        }

            this.$emit('get-index-counts')
            this.rows = []
            await this.getRows()
        },
        async updateInterventionComment(item) {
                const { data } = await this.$store.dispatch('interventions/updateInterventionCommentFromManagement', {
					comment: item.intervention_comment,
					prevision_id: item.prevision_id,
					intervention_id: item.intervention_id,
					filter: this.filter
				})
                item.intervention_id = data.intervention_id
                await this.$store.dispatch("alerts/success","Commentaire modifié")
        },
        async deleteOneTimeIntervention() {
            this.$emit('updating')
            await this.$store.dispatch('planningManagement/deleteOneTimeIntervention', {intervention_id: this.deleteOneTimeInterventionModal.data.intervention_id })
            this.deleteOneTimeInterventionModal.isOpen = false
            await this.$store.dispatch("alerts/success","Intervention supprimée")
            this.$emit('get-index-counts')
            this.rows = []
            await this.getRows()
        },
        checkRow(item) {
            this.$emit('updating')
            //Calculate the year of the intervention
            let year = null
            if (this.filter.endMonth.number >= item.month) {
                year = this.filter.endYear
            } else {
                year = this.filter.startYear
            }

            const data = {
                checked: item.checked,
                prevision_id: item.prevision_id,
                client_num: item.client_num,
                client_name: item.client_name,
                site_id: item.site_id,
                site_name: item.site_name,
                latitude: item.latitude,
                longitude: item.longitude,
                sector_name: item.sector_name,
                city: item.city,
                duration: item.duration,
                intervention_type: item.intervention_type,
                intervention_type_id: item.intervention_type_id,
                intervention_id: item.intervention_id,
                year: year
            }
            this.$emit('update-cart-interventions', data)
        },
        setCheckedRows(rows, interventions) {
            if (interventions) {
                // Handle previsions and one times
                if (this.type !== 'oneTimes') {
                    interventions = interventions.map((item) => { return { prevision_id: item.intervention.prevision_id, year: item.intervention.year }})
                    rows.forEach(item => {
                        //Calculate the year of the intervention
                        let year = null
                        if (this.filter.endMonth.number >= item.month) {
                            year = this.filter.endYear
                        } else {
                            year = this.filter.startYear
                        }
                        item.checked = false
                        if (interventions) {
                            let intervention = interventions.find((o) => {
                                return o.prevision_id === item.prevision_id && o.year === year
                            })
                            if (intervention) item.checked = true
                        }
                    })
                } else {
                    interventions = interventions.map(item => item.intervention.intervention_id)
                    rows.forEach(item => {
                        item.checked = false
                        if (interventions && interventions.includes(item.intervention_id)) {
                            item.checked = true
                        }
                    })
                }
            }
            return rows
        },
        contractInformationColor(item) {
            if (item.contractInformation.renewalStatus === 'cancelled') {
                return 'text-danger'
            } else if (item.contractInformation.renewalStatus === 'tacit') {
                return 'text-success'
            } else {
                return 'text-warning'
            }
        },
        refreshTable () {
            this.rows = []
            this.getRows()
        }
    },
    watch: {
        type() {
            this.refreshTable()
        },
        filter: {
            deep: true,
            handler() {
                this.refreshTable()
            }
        },
        selectedInterventions() {
            this.rows = this.setCheckedRows(this.rows, this.selectedInterventions)
        },
        cartStored() {
            //If cart has been stored, refresh table
            this.refreshTable()
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-table {
        .md-table-head {
            padding: 4px 8px;

            .md-table-head-label {
                font-size: .875rem;
            }
        }
        .md-table-row {
            .md-table-cell {
                padding: 0 8px;

                .md-table-cell-container {
                    font-size: .75rem;

                    .md-checkbox {
                        margin-right: 0;
                    }

                    .md-button.md-small-icon {
                        width: 27px !important;
                        height: 27px !important;
                        padding: 0 !important;
                        margin: 0.3125rem 1px;

                        .md-ripple {
                            height: auto;
                        }
                    }
                }
            }
        }
    }

    #schedules.md-list {
        .md-list-item {
            margin-bottom: .15rem;
            margin-left: 0;

            .md-list-item-content {
                font-size: 14px;
                min-height: 18px;
                padding: 0;

                * {
                    width: unset;
                }

                .day {
                    font-weight: 500;
                }
            }
        }
    }
}

</style>
